export type Subject = {
    id: string;
    name: string;
    deleted: boolean;
    created_at: string;
    updated_at: string;
}

export type SubjectAttributes = Omit<Subject, "id" | "created_at" | "updated_at">;

const SUBJECT_PRETTY_NAMES: Record<string, string> = {
    reading: 'Читання',
    prepare_to_school: 'Підготовка до школи',
    memory: "Пам'ять",
    english: 'Англійська',
    math: 'Математика',
    psychology: 'Психологія',
};

/**
 * Returns a human-readable (pretty) name for a subject.
 * Falls back to the raw name if no mapping exists, or '—' if null/undefined.
 */
export function getSubjectPrettyName(name: string | undefined | null): string {
    if (!name) return '—';
    return SUBJECT_PRETTY_NAMES[name] ?? name;
}
